import { UseQueryResult, useQuery } from '@tanstack/react-query'
import { useLeaseCompanyService } from 'app/leaseCompany/use-lease-company-service'
import { PERMISSION_REQUIRES_FLEET_LEASE_SETUP_TO_BE_DONE } from 'utils/Subscription/Permissions'
import { useHasPermission } from 'utils/Subscription/RequiredPermissions'

export function useHasLeaseCompanySetUp(): UseQueryResult<boolean> {
  const { existDefaultUser } = useLeaseCompanyService()
  const [isFleetLeaseWhiteLabelEnabled] = useHasPermission(PERMISSION_REQUIRES_FLEET_LEASE_SETUP_TO_BE_DONE)

  const accessResult = useQuery(
    ['lease-company-set-up'],
    async () => {
      const data = await existDefaultUser()

      return data.Exists
    },
    {
      refetchOnWindowFocus: false,
      enabled: isFleetLeaseWhiteLabelEnabled
    }
  )

  return accessResult
}
